import { render } from "./Manufacturer.vue?vue&type=template&id=6f3adf2c&scoped=true"
import script from "./Manufacturer.vue?vue&type=script&lang=ts"
export * from "./Manufacturer.vue?vue&type=script&lang=ts"

import "./Manufacturer.vue?vue&type=style&index=0&id=6f3adf2c&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-6f3adf2c"

export default script